/**
 * 促销设置查询参数数据
 */
 export class PromotionSearchParam {
  name?: string;
  offset: number;
  limit: number;
  constructor() {
    this.name = '';
    this.offset = 0;
    this.limit = 20;
  }
}

/**
 * 促销设置列表项
 */
 export interface PromotionListItem {
  /** 主键uuid */
  uuid: string;
  /** 显示ID */
  id: string;
  /** 促销名称 */
  name: string;
  /** 优惠面额 */
  discount_price: number;
  /** 满减面额 */
  offer_price: number;
  /** 适应订单类型 */
  order_type: PromotOrderTypes[];
  /** 使用限制 */
  usage_condition: UseLimitTypes;
  /** 启用状态 */
  is_active: boolean;
  /** 折扣率 */
  discount_rate: number;
}

/**
 * 促销[启用|禁用]接口参数
 */
export interface PromotionStatusParams {
  uuid: string;
  is_active: boolean;
  phone: string;
  code: string;
}

/**
 * 促销设置使用限制枚举
 */
 export enum UseLimitTypes {
  /** 不限 */
  Unlimited = 0,
  /** 仅首单可用 */
  FirstOrder = 1,
}

export enum PromotOrderTypes {
  /** 库存订单(药品订单) */
  StockOrder = 1,
}




// WEBPACK FOOTER //
// ./src/entity/PromotionEntity.ts